import { CalendarRelocations } from 'app/core/store/calendar/relocations/calendar-relocations.interface';

export const CALENDAR_FLORDERS_INITIAL_STATE: CalendarRelocations = {
  data: {
    dates: [],
    legend: [],
  },
  loading: false,
  loaded: false,
  deliveryDaysRequesting: false,
  deliveryDaysRequested: false,
  selectedTemplate: null,
  availableDays: null,
  UI: {
    startDate: null,
    endDate: null,
  },
};
